/** @jsxImportSource @emotion/react */
import { Typography } from '@mui/material'
import { TooltipModel } from 'chart.js'
import * as classes from './styles'

type TooltipProps = {
  data: TooltipModel<'line'> | null
}

export const ChartTooltip = ({ data }: TooltipProps) => {
  const value = data?.dataPoints[0].raw
  const { tooltipStyles, arrowStyles } = getStyles(data)

  return (
    <div css={classes.tooltipWrapper} style={tooltipStyles}>
      <span css={classes.tooltipArrow} style={arrowStyles} />

      <div css={classes.tooltipInner}>
        <div css={classes.badge}>
          <span css={classes.dot}></span>
          <Typography css={classes.tooltipText}>Used Promo</Typography>
        </div>

        <Typography css={classes.tooltipText}>{value?.toString()}</Typography>
      </div>
    </div>
  )
}

const getStyles = (data: TooltipModel<'line'> | null) => {
  const isVisible = data?.opacity === 1
  const tooltipWidth = 162
  const offset = 20
  let top = 0
  let left = 0
  let displayToTheLeft = false
  if (data) {
    const width = data.chart.width
    const { caretX, caretY } = data
    top = caretY
    left = caretX + offset
    displayToTheLeft = caretX > width / 2
  }

  const tooltipStyles = {
    opacity: isVisible ? 1 : 0,
    top: top,
    ...(displayToTheLeft
      ? {
          left: left - tooltipWidth - offset,
          flexDirection: 'row-reverse' as const,
        }
      : {
          left: left,
        }),
  }

  const arrowStyles = displayToTheLeft
    ? {
        rotate: '90deg',
        marginLeft: '-8px',
      }
    : {
        rotate: '-90deg',
        marginRight: '-8px',
      }

  return {
    tooltipStyles,
    arrowStyles,
  }
}
